const Form105EN = {
    stepName: {
        importantNotes: "Important Notes",
        partA: "Select the document(s) for submission",
        confirmation: "Confirmation",
    },

    label: {
        applicationPurpose: "Submit document(s)",
        sectionName: "Form Name",
        contactPerson: "Contact person of this submission",
        telephoneNo: "Telephone number of the contact person",
        emailAddress: "E-mail address of the contact person",
        uploadFiles: "Choose the file(s) to be submitted",
        reoCode: "Submit a copy to the Regional Education Office",
        contactInformation:
            "For matters related to the submission, please contact {{sectionName}} at {{sectionTel}}.",
        contactInformationNotTel:
            "For matters related to the submission, please contact {{sectionName}}.",
        scrnOrOrg: "School / Organisation",
        submittedTo: "Please Select:",
        conditionsCheck:
            "I confirm that the above {{uploadFilesLength}} file(s) is/are to be submitted to {{sectionName}}.",
        helpdesk:
            "For technical support, please contact the Helpdesk of EDB e-Form Submission System at 2694 5892.",
        logout: "Not logged in, can't submit this form.",
    },
    errorMsg: {
        pdfSignRequired: "Please sign the PDF.",
        exceedTotalSize: "Maximum total size of files is 45MB.",
    },
    AttachmentInstruction1: "Acceptable file types: {{types}}",
    AttachmentInstruction2: "Maximum size of each file is {{size}}MB.",
    AttachmentInstruction3:
        "Maximum length of file name is {{length}} characters.",
    AttachmentInstruction4: `Please use the "Add" button to add more files (max. {{files}}) if needed.`,
    AttachmentInstruction5: "Maximum total size of files is 45MB.",
};

export default Form105EN;
